import { render, staticRenderFns } from "./homeTabs.vue?vue&type=template&id=15a8705e&scoped=true&"
import script from "./homeTabs.vue?vue&type=script&lang=js&"
export * from "./homeTabs.vue?vue&type=script&lang=js&"
import style0 from "./homeTabs.vue?vue&type=style&index=0&lang=css&"
import style1 from "./homeTabs.vue?vue&type=style&index=1&id=15a8705e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a8705e",
  null
  
)

export default component.exports